module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Regular.7b2d793.woff";